export default "__VITE_ASSET__Cxs9nhXg__"